import {
    ThemeProvider as BaseThemeProvider,
    createTheme,
} from '@mui/material/styles';
import { FC, ReactNode, useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { themeState } from '../state/atoms/themeAtoms';
import { getDesignTokens } from './theme';

const ThemeProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const themeMode = useRecoilValue(themeState);
    const theme = useMemo(
        () => createTheme(getDesignTokens(themeMode)),
        [themeMode]
    );

    return <BaseThemeProvider theme={theme}>{children}</BaseThemeProvider>;
};

export default ThemeProvider;
